/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

/** Defines translated labels for the anomaly identifiers provided by sensor metadata. */

export const anomalyTranslations = {
    de: {
        anomaly_pv: 'PV-Anomalieerkennung',
        anomaly_bl: 'Strom-Grundlasterkennung',
        anomaly_bl_night: 'Nacht-Strom-Grundlasterkennung',
        anomaly_heating_energy: 'Wärme-Anomalieerkennung',
        anomaly_water_bl: 'Wasserverlusterkennung',
        anomaly_gas_bl: 'Gas-Anomalieerkennung',
        'No (check)': 'Nein (prüfen)',
        'Outage in last 30 days': 'Ausfall in den letzten 30 Tagen',
        'Redispatch in last 30 days': 'Redispatch in den letzten 30 Tagen',
    },
    en: {
        anomaly_pv: 'PV anomaly detection',
        anomaly_bl: 'Electricity base load detection',
        anomaly_bl_night: 'Night-time electricity base load detection',
        anomaly_heating_energy: 'Heat anomaly detection',
        anomaly_water_bl: 'Water loss detection',
        anomaly_gas_bl: 'Gas anomaly detection',
        'No (check)': 'No (check)',
        'Outage in last 30 days': 'Outage in the last 30 days',
        'Redispatch in last 30 days': 'Redispatch in the last 30 days',
    },
    es: {
        anomaly_pv: 'Detección de anomalías fotovoltaicas',
        anomaly_bl: 'Detección de carga base eléctrica',
        anomaly_bl_night: 'Detección de carga base eléctrica nocturna',
        anomaly_heating_energy: 'Detección de anomalías térmicas',
        anomaly_water_bl: 'Detección de pérdidas de agua',
        anomaly_gas_bl: 'Detección de anomalías de gas',
        'No (check)': 'No (comprobar)',
        'Outage in last 30 days': 'Fallo en los últimos 30 días',
        'Redispatch in last 30 days': 'Redispatch en los últimos 30 días',
    },
} as const;
